
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { NextPage } from 'next';
import BlogTemplate from 'components/templates/BlogTemplate';
import { PageProps, ServerSideProps } from 'types/pages';
import { getStringOrLastItem } from 'helpers/path.helper';
import { mapNextLocaleToISOLanguageCode } from 'helpers/locale.helper';
import { getDocumentRelationsFromFile } from 'prismic/getDocumentRelations';
import { fetchDocumentContent } from 'prismic/helpers/fetchContent';
import { DomainType } from 'prismic/config';

const Blog: NextPage<PageProps> = ({ header, data, footer }) => {
  return <BlogTemplate header={header} data={data} footer={footer}></BlogTemplate>;
};

 async function _getServerSideProps({ locale, params }: ServerSideProps) {
  const { slug, domain } = params;

  const isoLangCode = mapNextLocaleToISOLanguageCode(locale);

  const uid = getStringOrLastItem(slug);

  const documentRelations = await getDocumentRelationsFromFile();

  const fetchedContent = await fetchDocumentContent({
    lang: isoLangCode,
    domain: domain as DomainType,
    isValidPath: true,
    uid,
    pageType: 'blog_item',
  });

  if (!fetchedContent?.data) {
    console.error(`No content found ->`, {
      lang: isoLangCode,
      domain: domain as DomainType,
      isValidPath: true,
      uid,
      pageType: 'blog_item',
    });

    return {
      notFound: true,
    };
  }

  const { data, header, footer, type } = fetchedContent;

  return {
    props: {
      type,
      header,
      footer,
      data,
      documentRelations,
      sharedData: null,
      domain: domain as DomainType,
    } as PageProps,
  };
}

export default Blog;


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/[domain]/blog/[slug]',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  